// extracted by mini-css-extract-plugin
export default {"container":"jobs-container_container__liM8W"};